import {
	parse,
	format,
	parseJSON,
	isValid,
	differenceInMinutes,
} from 'date-fns/esm';

export const getToday = () => {
	const date = new Date();
	date.setHours(0, 0, 0, 0);
	return date;
};

export const getFormattedDate = (d, f) => {
	let date = d;
	try {
		date = parse(d);
	} catch (err) {
		try {
			date = parseJSON(d);
		} catch (err2) {
			// ignore
		}
	}
	return format(date, f);
};

export const addMinutesVanilla = (date, minutes) => {
	try {
		return new Date(date.getTime() + minutes * 60000);
	} catch (err) {
		try {
			if (date && typeof date === 'string') {
				return addMinutesVanilla(new Date(date), minutes);
			}
		} catch (errInner) {
			console.error('Error adding minutes. Try parsing', { errInner });
			return date;
		}
	}
};

export const getNiceDate = (d, isJsonDate = false) => {
	let date = d;
	if (typeof d === 'string') {
		date = isJsonDate ? parseJSON(d) : parseDate(d);
	}
	return format(date, 'EEE, MMM do, yyyy');
};

export const getNiceDateNoYear = (d, isJsonDate = false) => {
	let date = d;
	if (typeof d === 'string') {
		date = isJsonDate ? parseJSON(d) : parseDate(d);
	}
	return format(date, 'EEE, MMM do, hh:mm a');
};

export const getVanillaDate = d => (typeof d === 'string' && new Date(d)) || d;

export const getNiceDateVanilla = d => {
	if (!d) return d;

	return new Date(d).toLocaleDateString('en-US', {
		day: 'numeric',
		month: 'short',
		year: 'numeric',
		hour: 'numeric',
		minute: 'numeric',
		hour12: true,
	});
};

export const dateDiffInMins = (laterDate, earlierDate) =>
	differenceInMinutes(getVanillaDate(laterDate), getVanillaDate(earlierDate));

export const parseDate = d => {
	let date = '';

	try {
		//  "2020-07-10 12:00:00 AM"
		date = parse(d, 'yyyy-MM-dd h:mm:ss a', new Date());
		if (!isValid(date)) throw new Error();
		return date;
	} catch (_) {
		try {
			//  "7/10/2020 12:00:00 AM"
			date = parse(d, 'M/d/yyyy h:mm:ss a', new Date());
			if (!isValid(date)) throw new Error();
			return date;
		} catch (ex) {
			throw new Error(
				`Error parsing the date for the value "${d}". Both parsers failed.`
			);
		}
	}
};

export const isValidDate = d => d instanceof Date && !Number.isNaN(d);

export const localeDate = date => {
	if (!date) return null;
	const d = new Date(date);
	if (!isValidDate(d)) return '';
	return d
		.toLocaleString()
		.slice(0, 10)
		.replace(',', '')
		.trim();
};

export const minToHourAndMin = mins => {
	const h = Math.floor(mins / 60);
	const m = mins % 60;
	return { h, m };
};

export const getNiceHourAndMin = (h = 0, m = 0) => {
	if (h === 0 && m === 0) return 0;
	let out = '';
	if (h > 0) {
		out += `${h} hour`;
		if (h > 1) out += 's';
	}
	if (h > 0 && m > 0) out += ' and ';
	if (m > 0) {
		out += `${m} minute`;
		if (m > 1) out += 's';
	}
	return out;
};

export const minToNiceHourAndMin = mins => {
	const { h, m } = minToHourAndMin(mins);
	return getNiceHourAndMin(h, m);
};

export const decimalToNiceHourAndMin = decimal => {
	const { h, m } = minToHourAndMin(parseFloat(decimal) * 60);
	return getNiceHourAndMin(h, m);
};

export const minToDecimalHour = mins => {
	const { h, m } = minToHourAndMin(mins);
	const dec = parseInt((m / 6) * 10, 10);

	return `${h}.${dec < 10 ? '0' : ''}${dec}`;
};

// https://stackoverflow.com/questions/22820335/javascript-convert-hhmm-to-decimal#answer-22820471
// modified
export const timeToDecimal = date => {
	if (!isValidDate(date)) return date;
	const d = new Date(date || null);
	const h = d.getHours();
	const m = d.getMinutes();
	const dec = parseInt((m / 6) * 10, 10);

	// return parseFloat(`${parseInt(arr[0], 10)}.${dec < 10 ? '0' : ''}${dec}`);
	return `${parseInt(h, 10)}.${dec < 10 ? '0' : ''}${dec}`;
};

// export const timeToDate = (h = 0, m = 0) => {
export const timeToDate = t => {
	let h;
	let m;
	if (!t) h = 0;
	else if (typeof t === 'string') [h, m] = t.split('.');
	else return t;

	const d = new Date('0');
	if (h !== 0) d.setHours(parseInt(h, 10), parseInt(m, 10));
	return d;
};

export const getFirstAndLastDayOfMonth = d => {
	const y = d.getFullYear();
	const m = d.getMonth();
	return {
		firstDay: new Date(y, m, 1),
		lastDay: new Date(y, m + 1, 0),
	};
};
